import React, { createContext, useContext, useEffect, useReducer } from 'react';

import { getBackendInformation } from 'utility/Provide/BackendInformation';
import { CommunicationContext } from 'utility/Provide/Context/PageContext';

import { buildFeatureMap } from './mapBuilder';
import { FeatureReducer } from './reducer';
import { FeatureAction } from './reducer/types';

const initialFeatures = buildFeatureMap(getBackendInformation().features);

export const FeatureContext = createContext(initialFeatures);

export const FeatureProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    const [featureMap, dispatch] = useReducer(FeatureReducer, initialFeatures);
    const { react } = useContext(CommunicationContext);

    useEffect(() => {
        react.bind('init-async-features', (features) => {
            dispatch({
                type: FeatureAction.InitAsync,
                payload: features,
            });
        });
        react.bind('activate-feature', (feature) => {
            dispatch({
                type: FeatureAction.ActivateFeature,
                payload: feature,
            });
        });
        react.bind('deactivate-feature', (feature) => {
            dispatch({
                type: FeatureAction.DeactivateFeature,
                payload: feature,
            });
        });
        react.bind('update-feature', (updateInfo) => {
            dispatch({
                type: FeatureAction.UpdateFeatureState,
                payload: {
                    name: updateInfo.name,
                    activate: updateInfo.activate,
                },
            });
        });

        return () => {
            react.unbind('init-async-features');
            react.unbind('activate-feature');
            react.unbind('deactivate-feature');
            react.unbind('update-feature');
        };
    });

    return (
        <FeatureContext.Provider value={featureMap}>
            {children}
        </FeatureContext.Provider>
    );
};
